export const COMPANY_DEFAULT_SORT = {
  sortedColumn: 'name',
  sortedColumnOrder: 'ascend'
}

export const COMPANY_STATUS = [
  {
    key: 0,
    value: '',
    title: 'All'
  },
  {
    key: 1,
    value: 1,
    title: 'Active'
  },
  {
    key: 2,
    value: 0,
    title: 'Inactive'
  }
]

export const COMPANY_TEST = [
  {
    key: 0,
    value: '',
    title: 'All'
  },
  {
    key: 1,
    value: 1,
    title: 'Testing'
  },
  {
    key: 2,
    value: 0,
    title: 'Real'
  }
]

export const COMPANY_TYPE = [
  {
    key: 0,
    value: '',
    title: 'All'
  },
  {
    key: 1,
    value: 1,
    title: 'Physician'
  },
  {
    key: 2,
    value: 2,
    title: 'Payer'
  }
]

export const APPOINTMENT_OVERLAPPING_TYPES = {
  1: 'Allow meeting overlaps',
  2: 'Show warning',
  3: "Don't allow meeting overlaps"
}

export const CALENDAR_DEFAULT_PAGES = {
  1: 'Calendar',
  2: 'List'
}
